import React from 'react'
import Fragment from '../common/fragment'

function FragmentAB(props) {
  return (
    <Fragment pos="b" {...props}>
      <p>
        Los evangélicos predicaban sobre un templete, al atardecer, en Salamanca. La plaza
    estaba vacía, pero en el aire sus voces temblaban con un viento suave y la
    confianza. A lo lejos resonaba, cada cierto tiempo, la palabra “Dios”, dicha con una
    voz profunda. Escuchábamos los trenes que pasaban por ahí cerca. De la refinería,
    el olor y el polvo. En la iglesia la misa parecía oculta y secreta. El mismo dios y los
    lenguajes del aire. ¿A quién le predicaban si en esa plaza de piedra sólo había
    algunas parejas ensimismadas, con helados en sus manos?, ¿quién escuchaba sus
    invocaciones si todo parecía desierto? La prédica no necesita escucha. Si se invocan
    otras fuerzas, no hay testigos. El tren era una invocación a las energías temblorosas de este mundo. Cada cierto tiempo, se escuchaba su sonido pesado y
    continuo, como si respondiera a esas voces, secas y curvas, que anunciaban un
    reino, otro mundo.
      </p>
    </Fragment>
  )
}


export default FragmentAB
